import React, { useState } from "react";
import { ChevronRight, X } from "lucide-react";
import { Link } from "react-router-dom";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const closeMenu = () => {
    setIsOpen(false);
  };

  const navLinks = [
    { name: "AI Smile Simulation", id: "ai-simulation" },
    { name: "Solutions", id: "solutions" },
    { name: "Pricing", href: "/pricing" },
    { name: "Contact", href: "/contact" },
  ];

  const handleNavClick = (link, e) => {
    if (link.id) {
      e.preventDefault();
      const element = document.getElementById(link.id);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      } else {
        window.location.href = `/#${link.id}`;
      }
      closeMenu();
    }
  };

  return (
    <div className="fixed top-0 left-0 right-0 z-50 w-full">
      <nav className="max-w-7xl mx-auto px-3 sm:px-4 lg:px-6 py-4">
        <div className="flex items-center justify-between rounded-full bg-white/80 backdrop-blur-lg px-4 md:px-6 py-3 shadow-lg border border-white/20 relative">
          <div className="flex items-center gap-2">
            <Link to="/" className="flex items-center gap-2">
              <img
                src="/logo_transparent.webp"
                alt="SmileReveal Logo"
                className="h-8 md:h-12"
              />
            </Link>
          </div>

          <div className="hidden lg:flex items-center space-x-8 text-sm font-medium text-gray-600">
            {navLinks.map((link) =>
              link.href ? (
                <Link
                  key={link.name}
                  to={link.href}
                  className="hover:text-gray-900 transition-colors"
                >
                  {link.name}
                </Link>
              ) : (
                <button
                  key={link.name}
                  onClick={(e) => handleNavClick(link, e)}
                  className="hover:text-gray-900 transition-colors"
                >
                  {link.name}
                </button>
              )
            )}
          </div>

          <div className="flex items-center gap-2 md:gap-6 text-sm font-medium">
            <a
              href="https://app.smilereveal.io"
              className="hidden lg:block text-gray-900 hover:text-brand-dark"
            >
              Login
            </a>
            <a
              href="https://app.smilereveal.io"
              className="hidden lg:flex items-center gap-2 rounded-full bg-black px-6 py-2.5 text-white transition-all hover:bg-gray-800 group"
            >
              Lets Get Started
              <div className="flex items-center text-current">
                <ChevronRight className="h-4 w-4 opacity-40 group-hover:translate-x-0.5 transition-transform" />
                <ChevronRight className="h-5 w-5 opacity-70 -ml-2.5 group-hover:translate-x-0.5 transition-transform delay-75" />
                <ChevronRight className="h-6 w-6 opacity-100 -ml-3.5 group-hover:translate-x-0.5 transition-transform delay-150" />
              </div>
            </a>
            <button
              onClick={toggleMenu}
              className="lg:hidden p-2 text-gray-600 hover:text-gray-900 hover:bg-gray-100 rounded-full transition-colors focus:outline-none"
              aria-label="Toggle menu"
            >
              {isOpen ? (
                <X className="h-6 w-6" />
              ) : (
                <img src="/svgs/menu.svg" alt="Menu" className="h-6 w-6" />
              )}
            </button>
          </div>
        </div>

        {/* Mobile Menu Backdrop */}
        {isOpen && (
          <div
            className="fixed inset-0 bg-black/5 backdrop-blur-sm z-40 lg:hidden"
            onClick={closeMenu}
          ></div>
        )}

        {/* Mobile Menu Panel */}
        <div
          className={`fixed left-0 right-0 top-24 mx-4 lg:hidden z-50 transform transition-all duration-300 ease-in-out ${isOpen
            ? "translate-y-0 opacity-100 pointer-events-auto"
            : "-translate-y-4 opacity-0 pointer-events-none"
            }`}
        >
          <div className="bg-white rounded-3xl p-6 shadow-xl border border-gray-100">
            <div className="flex flex-col space-y-4">
              {navLinks.map((link) =>
                link.href ? (
                  <Link
                    key={link.name}
                    to={link.href}
                    className="text-gray-600 hover:text-gray-900 px-4 py-2 hover:bg-gray-50 rounded-xl transition-all font-medium text-lg"
                    onClick={closeMenu}
                  >
                    {link.name}
                  </Link>
                ) : (
                  <button
                    key={link.name}
                    onClick={(e) => handleNavClick(link, e)}
                    className="text-left text-gray-600 hover:text-gray-900 px-4 py-2 hover:bg-gray-50 rounded-xl transition-all font-medium text-lg"
                  >
                    {link.name}
                  </button>
                )
              )}
              <div className="h-px bg-gray-100 my-2"></div>
              <div className="flex flex-col space-y-3 pt-2">
                <a
                  href="https://app.smilereveal.io"
                  className="text-center text-gray-900 font-semibold py-2"
                  onClick={closeMenu}
                >
                  Login
                </a>
                <a
                  href="https://app.smilereveal.io"
                  className="flex items-center justify-center gap-2 rounded-full bg-black px-6 py-3.5 text-white transition-all hover:bg-gray-800 font-semibold group"
                  onClick={closeMenu}
                >
                  Lets Get Started
                  <div className="flex items-center text-current">
                    <ChevronRight className="h-4 w-4 opacity-40 group-hover:translate-x-0.5 transition-transform" />
                    <ChevronRight className="h-5 w-5 opacity-70 -ml-2.5 group-hover:translate-x-0.5 transition-transform delay-75" />
                    <ChevronRight className="h-6 w-6 opacity-100 -ml-3.5 group-hover:translate-x-0.5 transition-transform delay-150" />
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </nav>
    </div>
  );
};

export default Navbar;
